
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/revelation_order",
      function () {
        return require("private-next-pages/revelation_order.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/revelation_order"])
      });
    }
  